import React from 'react'
import Field from '../../../common/Field'
import Validator from '../../../common/Validator'
import Reflux from 'reflux'
import moment from 'moment'
import 'moment/locale/hu'
import 'react-datepicker/dist/react-datepicker.css'
import i18 from '../../../../i18'
import api from '../../../../source/api'
import utils from '../../../../helpers/bankHelper'
import BankStore from '../../../../store/bankstore'
import bankactions from '../../../../actions/bankactions'
import NotificationSystem from 'react-notification-system'
import {Link} from 'react-router-dom'
import DatePicker from 'react-date-picker'

class Rlb extends Reflux.Component {

    constructor(props) {
        super(props)
        this._notificationSystem = null
        this.state = {
            userconfigs: [],
            company: [],
            step: props.step,
            processing: false,
            company_id: props.location.match.params.id,
            fields: {
                //Mainbookkeeping codes, provided by user
                unknown_items_code: {value: '', error: '', role: {required: true}},
                bank_account_number_code: {value: '', error: '', role: {required: true}},
                bank_statement_number: {value: '', error: '', role: {required: false}},
                //Input files
                bankStatementFile: {value: '', error: '', role: {required: true}},
                partners: {value: '', error: '', role: {required: true}},
                buyer_supplier_bookkeeping_number_file_1: {value: '', error: '', role: {required: false}},
                buyer_supplier_bookkeeping_number_file_2: {value: '', error: '', role: {required: false}},
                job_number: {value: '', error: '', role: {required: false}},
                bank_exchange: {value: 'HUF', error: '', role: {required: true}},
                company_exchange: {value: 'HUF', error: '', role: {required: true}},
                extra_files: {value: [], error: '', role: {required: false}},
            },
            //bookkeeping intervall
            startDate: new Date(),
            endDate: new Date(),
            dateErrorMessage: '',
        }
        this.store = BankStore
    }

    componentDidMount = () => {
        window.scrollTo(0, 0)
        moment.locale('hu')
        this._notificationSystem = this.refs.notificationSystem

        api.get({url: 'bank/init?company_id=' + this.state.company_id}, true).then((response) => {
            let config = response.data.userconfigs;
            let fields = this.state.fields;

            fields.unknown_items_code.value = config.unknown_items_code;
            fields.bank_account_number_code.value = config.bank_account_number_code;
            fields.bank_statement_number.value = config.bank_statement_number;
            fields.job_number.value = config.job_number || '';

            this.setState({
                startDate: typeof config.start_date !== 'undefined' && config.start_date !== null ? new Date(config.start_date) : new Date(),
                endDate: typeof config.end_date !== 'undefined' && config.end_date !== null ? new Date(config.end_date) : new Date(),
                fields: fields,
                userconfigs: response.data.userconfigs,
                company: response.data.company,
            });

        })
    }

    _addNotification = (msg, type, time = 4) => {
        this.refs.notificationSystem.addNotification({
            message: msg,
            level: type,
            position: 'tc',
            autoDismiss: time
        })
    }

    setValue = (name, value, error) => {
        let fields = this.state.fields;
        fields[name].value = value;
        fields[name].error = error;
        this.setState({fields: fields});
    }

    validate = () => {
        let validator = Validator.validate(this.state.fields)
        let dateError = this.state.startDate > this.state.endDate;
        let error = validator.error || dateError;

        this.setState({
            fields: validator.fields,
            dateErrorMessage: dateError ? 'Kezdő dátum nem lehet nagyobb mint a zárás dátum' : ''
        })
        return !error;
    }

    nextStep = () => {
        if (!this.validate()) {
            return;
        }
        document.body.classList.toggle('loading-body', true);

        this.setState({
            step: this.state.step + 1,
            processing: true
        });

        const form = this.collectFormData()
        api.postFile({url: 'bank/steps/upload', data: form}, true).then((response) => {
            if (response.status === 200) {
                this.setState({processing: false})
                document.body.classList.remove('loading-body')
                this.setGlobalState(response.data)
            }
        }).catch((err) => {
            document.body.classList.remove('loading-body')
            this.setState({processing: false})
            this._addNotification(err.response.data.error.message, 'error')
        })
    }

    collectFormData = () => {
        let form = new FormData()
        let bankStatementFile = document.querySelector('#bankStatementFile')
        let partners = document.querySelector('#partners')
        let buyerSupplierFile1 = document.querySelector('#buyer_supplier_bookkeeping_number_file_1')
        let buyerSupplierFile2 = document.querySelector('#buyer_supplier_bookkeeping_number_file_2')

        form.append('bankStatementFile', bankStatementFile.files[0])
        form.append('buyerSupplierFile1', buyerSupplierFile1.files[0])
        form.append('buyerSupplierFile2', buyerSupplierFile2.files[0])
        form.append('partners', partners.files[0])

        form.append('startDate', moment(this.state.startDate).format('YYYY-MM-DD'))
        form.append('endDate', moment(this.state.endDate).format('YYYY-MM-DD'))
        form.append('company_id', this.state.company_id)
        form.append('unknown_items_code', this.state.fields.unknown_items_code.value)
        form.append('bank_account_number_code', this.state.fields.bank_account_number_code.value)

        if (this.state.fields.bank_statement_number.value) {
            form.append('bank_statement_number', this.state.fields.bank_statement_number.value)
        }
        form.append('job_number', this.state.fields.job_number.value)
        form.append('bank_exchange', this.state.fields.bank_exchange.value)

        for (let i = 0; i < this.state.fields.extra_files.value.length; i++) {
            form.append(`extra_files[${i}]`, this.state.fields.extra_files.value[i])
        }

        return form
    }

    setGlobalState = response => {
        let data = {
            date: {
                start: this.state.startDate,
                end: this.state.endDate
            },
            fields: this.state.fields,
            vszcompanies: response.vszcompanies,
            unprocessed: response.unprocessed,
            processed: response.processed,
            buyerSupplierFile1: response.files['SUPLIER-BUYER-FILE-1'] ? response.files['SUPLIER-BUYER-FILE-1'] : '',
            buyerSupplierFile2: response.files['SUPLIER-BUYER-FILE-2'] ? response.files['SUPLIER-BUYER-FILE-2'] : '',
            bankStatementFile: response.files.bankStatementFileUploadedFileName,
            partners: response.files.partners,
            company: this.state.company,
        }

        if (response.unprocessed !== null && !Object.keys(response.unprocessed).length
            && response.processed !== null && !Object.keys(response.processed).length) {
            bankactions.setFlag(false, 'bank')
            this._addNotification('Kérjük ellerőrizze a következő adatokat:  Bemenit fájlok és kiválasztott könyvelési időszak.', 'error')
            return
        }

        utils.resetLocalStorage()
        this.props.setBankState({
            dataVszItems: response.vszdata
        });
        utils.setStatements(response.statement)
        bankactions.setData(data)
        utils.setFileNames(response.files)

        this.props.setNextStep()
    }

    onElementChange = (event) => {
        let fields = this.state.fields;
        fields[event.target.name].value = event.target.value;
        this.setState({fields: fields})
    };

    onDateChange = (field, date) => {
        this.setState({[field]: date})
    };

    render() {
        return (
            <div className='col-12'>
                <h4 className='text-left'>Kiválasztott cég: {typeof this.state.company !== 'undefined' ? this.state.company.name : ''} (<Link className='link-color' to='/'>cég csere</Link>)</h4>
                <br/>
                <div className='row'>
                    <div className='col-md-3'>
                        <p>{i18.BANK._bookingIntervall}</p>
                    </div>
                    <div className='col-3'>
                        <DatePicker
                            className="date-picker"
                            required={true}
                            locale="hu-HU"
                            onChange={(date) => this.onDateChange('startDate', date)}
                            name="startDate"
                            value={this.state.startDate}
                        />
                    </div>
                    <div className='col-md-1'></div>
                    <div className='col-3'>
                        <DatePicker
                            className="date-picker"
                            locale="hu-HU"
                            onChange={(date) => this.onDateChange('endDate', date)}
                            name="endDate"
                            value={this.state.endDate}
                        />
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-6 offset-md-3'>
                        <p className={this.state.dateErrorMessage ? 'help-block help-block-error' : 'd-none'}><span className='error'><i className='fa fa-warning'></i> {this.state.dateErrorMessage}</span></p>
                    </div>
                </div>
                <table className='table table-striped  table-aibook-bordered'>
                    <tbody>
                    <tr>
                        <td>{i18.BANK._unknowItems}</td>
                        <td>
                            <Field
                                type='text'
                                id='unknown_items_code'
                                name='unknown_items_code'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>{i18.BANK._bankLedgerNumber}</td>
                        <td>
                            <Field
                                type='text'
                                id='bank_account_number_code'
                                name='bank_account_number_code'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>Bankkivonat szám</td>
                        <td>
                            <Field
                                type='text'
                                id='bank_statement_number'
                                name='bank_statement_number'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>Munkaszám</td>
                        <td>
                            <Field
                                type='text'
                                id='job_number'
                                name='job_number'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>Bank devizaneme</td>
                        <td>
                            <select
                                id='bank_exchange'
                                className='form-control bordered-input'
                                name='bank_exchange'
                                value={this.state.fields.bank_exchange.value}
                                style={{width: '150px', height: '28px'}}
                                onChange={(event) => this.onElementChange(event)}
                            >
                                <option value="HUF">HUF</option>
                                <option value="EUR">EUR</option>
                                <option value="USD">USD</option>
                            </select>
                        </td>
                    </tr>
                    </tbody>
                </table>

                <div className='row'>
                    <div className='col-4'>
                        <Field
                            type='file'
                            id='bankStatementFile'
                            name='bankStatementFile'
                            label={i18.BANK._bankStatement}
                            fileUploadEndpoint=''
                            classLabel='control-label'
                            classInput='file-input'
                            setValue={this.setValue.bind(this)}
                            state={this.state}
                            style={{width: '100%'}}
                        />
                    </div>
                    <div className='col-4'>
                        <Field
                            type='file'
                            id='partners'
                            name='partners'
                            label={i18.BANK._partnermaster}
                            fileUploadEndpoint=''
                            classLabel='control-label'
                            classInput='file-input'
                            setValue={this.setValue.bind(this)}
                            state={this.state}
                            style={{width: '100%'}}
                        />
                    </div>
                    <div className='col-4'>
                        <Field
                            type='file'
                            id='extra_files'
                            name='extra_files'
                            label='Gyűjtő számlák (GLS, MPL, SimplePay)'
                            fileUploadEndpoint=''
                            classLabel='control-label'
                            classInput='file-input'
                            setValue={this.setValue.bind(this)}
                            state={this.state}
                            style={{width: '100%'}}
                            multiple={true}
                        />
                    </div>
                </div>
                <div className='row'>
                    <div className='col-12 hr-separator'></div>
                </div>

                <div className='row'>
                    <div className='text-left col-6'>
                        <Field
                            type='file'
                            id='buyer_supplier_bookkeeping_number_file_1'
                            name='buyer_supplier_bookkeeping_number_file_1'
                            label='Vevő tábla'
                            fileUploadEndpoint=''
                            classLabel='control-label'
                            classInput='file-input'
                            setValue={this.setValue.bind(this)}
                            state={this.state}
                            style={{width: '100%'}}
                        />
                    </div>
                    <div className='text-left col-6'>
                        <Field
                            type='file'
                            id='buyer_supplier_bookkeeping_number_file_2'
                            name='buyer_supplier_bookkeeping_number_file_2'
                            label='Szállító tábla'
                            fileUploadEndpoint=''
                            classLabel='control-label'
                            classInput='file-input'
                            setValue={this.setValue.bind(this)}
                            state={this.state}
                            style={{width: '100%'}}
                        />
                    </div>
                </div>

                <div className='row'>
                    <div className='col-12'>
                        <br/>
                        <div className='next-step-btn-container'>
                            <a onClick={() => this.nextStep()} className={this.state.processing ? 'disabled next-step' : 'next-step'}>{this.state.processing ? i18.BUTTONS._processing : i18.BUTTONS._goToAccountAssignment}</a>
                        </div>
                    </div>
                </div>
                <NotificationSystem ref='notificationSystem'/>
            </div>
        )
    }
}

export default Rlb


// WEBPACK FOOTER //
// ./src/components/bank/steps/upload/Rlb.js